import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';
import { percentPrecision, TipologiaSoggettoGap } from '@ideapa/common-utils';

export const ENTITY = 'gap';

export const ENTITY_PLURAL = 'Gap';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Ragione Sociale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'partecipataEnte.partecipata.ragioneSociale',
  },
  {
    elementLabel: 'Tipologia Partecipazione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'partecipataEnte.tipologiaPartecipazione.descrizione',
    minWidth: 160,
    maxWidth: 200,
  },
  {
    elementLabel: 'Tipologia Soggetto',
    filterType: FilterType.enum,
    fieldType: FieldType.enum,
    field: 'partecipataEnte.swControllata',
    elementValues: TipologiaSoggettoGap,
    minWidth: 140,
    maxWidth: 160,
  },
  {
    elementLabel: '% Partec.',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    precision: percentPrecision,
    field: 'partecipataEnte.percentualePossessoDiretta',
    contentAlignment: ContentAlignmentEnum.Right,
    minWidth: 110,
    maxWidth: 150,
  },
  {
    elementLabel: '% Partec. Totale',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    precision: percentPrecision,
    field: 'partecipataEnte.percentualePossessoTotale',
    contentAlignment: ContentAlignmentEnum.Right,
    minWidth: 110,
    maxWidth: 150,
  },
  {
    elementLabel: 'Motivo Inclusione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'motivoInclusione',
  },
  {
    elementLabel: 'Motivo Esclusione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'motivoEsclusione',
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;

export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;

export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;

export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;

export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
